var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6174721,22.4907326 L13.6174721,12.9174757 L17.0772402,12.9174757 L17.5957069,9.18270079 L13.6174721,9.18270079 L13.6174721,6.80097087 C13.6174721,5.71668138 13.9365286,4.98455428 15.6115748,4.98455428 L17.7352941,4.98455428 L17.7352941,1.64827891 C17.3663851,1.60194175 16.1001299,1.5 14.6344645,1.5 C11.5635464,1.5 9.46973862,3.24227714 9.46973862,6.43027361 L9.46973862,9.18270079 L6,9.18270079 L6,12.9174757 L9.46973862,12.9174757 L9.46973862,22.5 L13.6174721,22.5 L13.6174721,22.4907326 Z",
    id: "path-c-gzce-7q_-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube-2",
    transform: "translate(-233.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube",
    transform: "translate(69.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share",
    transform: "translate(44.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    transform: "translate(120.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle-Color",
    fill: "#FFFFFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-c-gzce-7q_-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-c-gzce-7q_-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-Color",
    fill: "#051C2C",
    fillRule: "nonzero",
    xlinkHref: "#path-c-gzce-7q_-1"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.36179df6764b0b2766f5da4031368e4d.svg";
export { ForwardRef as ReactComponent };